import React from 'react';
import { Inner } from './partials';
import { ThankYou } from './ThankYou';
var RESULTS_PAGE = {
  thankyou: {
    component: ThankYou
  }
};
export var PillResult = function PillResult(_ref) {
  var resultPage = _ref.resultPage,
    pillProps = _ref.pillProps;
  var type = resultPage.type;
  var definition = RESULTS_PAGE[type] || RESULTS_PAGE.thankyou;
  var ResultsComponent = definition.component;
  return React.createElement(Inner, null, React.createElement(ResultsComponent, {
    resultPage: resultPage,
    pillProps: pillProps
  }));
};